module.exports = __webpack_public_path__ + "img/21.325cd2ee.png";